module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'circle-legend': _vm.centerClass
    }
  }, [_c('svg', {
    attrs: {
      "width": _vm.width,
      "height": _vm.height,
      "transform": _vm.translate
    }
  }, [_c('g', {
    attrs: {
      "id": _vm.field,
      "width": _vm.width,
      "transform": "translate(20,15)"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-30f48334"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CircleLegendChart.vue
// module id = 370
// module chunks = 1